/* eslint-disable no-param-reassign */
import { BaseClient as InfraBaseClient } from 'vue-infra';
import { merge } from 'lodash';
import Config from '@config/config';
import BaseClient from '@core/common/BaseClient';
import { RESOURCES_CONFIGURATION_TIMEOUT as TIMEOUT } from '@config/Consts';

const EVENTS = BaseClient.EVENTS;

// It is the most suitable place to put a constant that symbolizes different virtual resources,
// while using the same resource but passing different parameters
const AGENT_STATUS_RESOURCES = {
  AGENT_STATUS_LOAD: 'agentStatusLoad',
  AGENT_STATUS_ASSIGNED: 'agentStatusAssigned',
};

const RESOURCES = {
  AGENT_STATUS: 'agentStatus',
  SEARCH_AGENTS: 'searchAgents',
  SEARCH_ENGAGEMENTS: 'searchEngagements',
  SEARCH_CONVERSATIONS_DATA: 'searchConversationData',
};

const RESOURCES_CONFIGURATION = {
  [RESOURCES.AGENT_STATUS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'MessagingEngagementsHistory.AgentStatus',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
  [RESOURCES.SEARCH_AGENTS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'MessagingEngagementsHistory.SearchAgents',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
  [RESOURCES.SEARCH_ENGAGEMENTS]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'MessagingEngagementsHistory.SearchEngagements',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
  [RESOURCES.SEARCH_CONVERSATIONS_DATA]: {
    ALLOWED_METHODS: [BaseClient.HTTP_METHODS.POST],
    URL_KEY: () => 'MessagingEngagementsHistory.SearchConversationData',
    TIMEOUT: [TIMEOUT.GENERAL_RESOURCE],
  },
};

function createInfraBaseClient(options, config) {
  const { baseURL, apiResource } = BaseClient.urlResolver.resolveUrl(RESOURCES_CONFIGURATION[config.resource]);

  const infraBaseClientOptions = {
    allowedMethods: RESOURCES_CONFIGURATION[config.resource].ALLOWED_METHODS,
    config: {
      baseURL,
      timeout: RESOURCES_CONFIGURATION[config.resource].TIMEOUT,
    },
    source: {
      appName: Config.moduleName,
      contextName: config.contextName,
    },
    body: {
      v: apiResource.version,
    },
    retryConfig: BaseClient.getClientRetryConfig,
  };

  merge(infraBaseClientOptions, options);

  const client = new InfraBaseClient(infraBaseClientOptions);

  return client;
}

class MsgHistoryClient extends BaseClient {
  constructor({
    infraBaseClientOptions,
    ...options
  }) {
    const infraBaseClient = createInfraBaseClient(infraBaseClientOptions, options);
    super({
      name: 'MsgHistoryClient',
      infraBaseClient,
      ...options,
    });
  }
}

MsgHistoryClient.EVENTS = EVENTS;

export {
  RESOURCES,
  AGENT_STATUS_RESOURCES,
  EVENTS,
  MsgHistoryClient,
};
